import { ref, update } from "firebase/database";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { getFirebase } from "../firebase/init.js";
import { type EditableCharacter, adjustFp } from "../lib/character-edits.js";

interface Props {
  characterPath: string;
  character: EditableCharacter;
}

export default function CharacterFpEditor({ characterPath, character }: Props): ReactElement {
  const { t } = useTranslation();

  async function bump(delta: number): Promise<void> {
    const { db } = getFirebase();
    await update(ref(db), adjustFp(characterPath, character, delta));
  }

  return (
    <section className="flex items-center gap-3">
      <span className="text-sm font-semibold uppercase text-muted-foreground">{t("sheet.fp")}</span>
      <button
        type="button"
        aria-label={t("edit.fp.decrement")}
        className="rounded border px-2 py-0.5"
        onClick={() => bump(-1)}
      >
        −
      </button>
      <span className="font-mono">{character.fp}</span>
      <button
        type="button"
        aria-label={t("edit.fp.increment")}
        className="rounded border px-2 py-0.5"
        onClick={() => bump(+1)}
      >
        +
      </button>
      <span className="text-xs text-muted-foreground">
        / {t("edit.fp.refresh")} {character.refresh}
      </span>
    </section>
  );
}
